module.exports = __webpack_public_path__ + "img/outside_osakana.6fa1431e.jpg";